import type { ModFeature } from './modFeatures';
import type { PrivateModeSettings } from '../global/types/rasiTechModules';
import type { RasiTechSettings } from '../global/types/sharedState';

import {
  appendActivity,
  getAccessControlData,
  isBlockedUserId,
  isPaidUserId,
  loadAccessControl,
  reloadAccessControl,
  subscribeAccessControl,
} from '../rasitech/accessControlStore';

export { reloadAccessControl, subscribeAccessControl };
import { RASITECH_SUPER_ADMIN_USER_ID, RASITECH_WELCOME_SEEN_PREFIX } from '../rasitech/constants';

/** Semua fitur mod ini gratis untuk semua user. */
export const PAID_MOD_FEATURES: (keyof RasiTechSettings)[] = [];

/** Semua opsi Private Mode gratis untuk semua user. */
export const PAID_PRIVATE_MODE_KEYS: (keyof PrivateModeSettings)[] = [];

let activeUserId: string | undefined;

export function setRasiTechAccessUserId(userId: string | undefined) {
  activeUserId = userId;
}

export function getRasiTechAccessUserId() {
  return activeUserId;
}

export function isSuperAdmin(userId?: string) {
  return (userId || activeUserId) === RASITECH_SUPER_ADMIN_USER_ID;
}

export function canUsePaidFeatures(userId?: string) {
  const id = userId || activeUserId;
  if (!id) return false;
  return isPaidUserId(id);
}

export function canUsePaidModFeature(feature: ModFeature, userId?: string) {
  if (!PAID_MOD_FEATURES.includes(feature)) return true;
  return canUsePaidFeatures(userId);
}

export function canUsePaidPrivateMode(key: keyof PrivateModeSettings, userId?: string) {
  if (!PAID_PRIVATE_MODE_KEYS.includes(key)) return true;
  return canUsePaidFeatures(userId);
}

export function isUserBlockedFromApp(userId?: string) {
  const id = userId || activeUserId;
  if (!id) return false;
  return isBlockedUserId(id);
}

export function hasSeenWelcome(userId: string) {
  if (typeof localStorage === 'undefined') return true;
  return localStorage.getItem(`${RASITECH_WELCOME_SEEN_PREFIX}${userId}`) === '1';
}

export function markWelcomeSeen(userId: string) {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(`${RASITECH_WELCOME_SEEN_PREFIX}${userId}`, '1');
}

export async function initRasiTechAccess() {
  await loadAccessControl();
}

export async function logRasiActivity(
  userId: string,
  type: Parameters<typeof appendActivity>[1],
  message: string,
) {
  await loadAccessControl();
  await appendActivity(userId, type, message);
}

export function getAccessLists() {
  const data = getAccessControlData();
  return {
    paidUserIds: data.paidUserIds,
    blockedUserIds: data.blockedUserIds,
    activityLog: [...data.activityLog].reverse(),
  };
}
